import axiosInstance from '../axiosInstance';

export default {
  async getBuildInfo(): Promise<string[]> {
    const response = await axiosInstance.get(`/api/build/`);
    return response.data;
  }
};
